module.exports = __webpack_public_path__ + "static/media/sidebar-settings.52a5df67.svg";